import { useMemo } from 'react';
import { useGetLocations } from 'src/hooks';

import { getSelectedLocationGroupIds } from '../modules/reviewPageContent/helper';

export const usePublishableLocationGroups = (
  selectedLocationGroups: Set<number | string>,
  selectedLocationGroupId?: number | string,
) => {
  const selectedLocationGroupIds = getSelectedLocationGroupIds(
    selectedLocationGroups,
    selectedLocationGroupId,
  );
  const {
    data: selectedLocationGroupLocations = [],
    isLoading: isSelectedLocationGroupLocationsLoading,
  } = useGetLocations(
    selectedLocationGroupIds.length
      ? [`location_group_id=${selectedLocationGroupIds.join('|')}`]
      : [],
  );

  const publishableLocationGroupIds = useMemo(() => {
    if (isSelectedLocationGroupLocationsLoading) {
      return selectedLocationGroupIds;
    }

    return selectedLocationGroupIds.filter((locationGroupId) =>
      selectedLocationGroupLocations.some((location) =>
        location.location_group_id.includes(locationGroupId),
      ),
    );
  }, [
    isSelectedLocationGroupLocationsLoading,
    selectedLocationGroupIds,
    selectedLocationGroupLocations,
  ]);

  const hasLocationGroupsWithoutLocations =
    selectedLocationGroupIds.length > 0 &&
    publishableLocationGroupIds.length > 0 &&
    publishableLocationGroupIds.length < selectedLocationGroupIds.length;

  return {
    publishableLocationGroupIds,
    hasLocationGroupsWithoutLocations,
  };
};
